import { render, staticRenderFns } from "./playmusic.vue?vue&type=template&id=20621486&scoped=true"
import script from "./playmusic.vue?vue&type=script&lang=js"
export * from "./playmusic.vue?vue&type=script&lang=js"
import style0 from "./playmusic.vue?vue&type=style&index=0&id=20621486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20621486",
  null
  
)

export default component.exports